import React from 'react'
import HomeIcon from '@material-ui/icons/Home'
import Item from './DashboardSidebarItem'
import PublicIcon from '@material-ui/icons/Public'
import SaveIcon from '@material-ui/icons/Save'
import Setting from '@material-ui/icons/Settings'
import HelpIcon from '@material-ui/icons/Help'

const styles = {
  icon: {
    width: 40,
    height: 40,
  }
}

const items = [
  {
    itemName: 'Dashboard',
    link: '/',
    icon: <img src="/icons/Dashboard150.png" alt="overview_icon" style={styles.icon} />
  },
  {
    itemName: 'Campaigns',
    link: '/advertiser/campaigns',
    icon: <img src="/icons/Campaigns150.png" alt="campaigns_icon" style={styles.icon} />
  },
  {
    itemName: 'Customer Lists',
    link: '/advertiser/customerlists',
    icon: <img src="/icons/Customer-Lists150.png" alt="customer_list_icon" style={styles.icon} />
  },
  {
    itemName: 'Account Settings',
    link: '/advertiser/accountsettings',
    icon: <img src="/icons/Account-Settings150.png" alt="customer_list_icon" style={styles.icon} />
  },
  {
    itemName: 'Subscription',
    link: '/advertiser/helps',
    icon: <img src="/icons/Subscription150.png" alt="subscription_icon" style={styles.icon} />
  },
  {
    itemName: 'Support',
    link: '/advertiser/customerservice',
    icon: <img src="/icons/Support150.png" alt="support_icon" style={styles.icon} />
  }
];

const ListItems = ({onHandleDrawerClose}) => {
  return items.map((i, index) => {
    return (
      <div key={index}>
        <Item
          itemName={i.itemName}
          link={i.link}
          icon={i.icon}
          onHandleDrawerClose={onHandleDrawerClose}
        />
      </div>
    )
  });
};

export default ListItems
